import Vue from 'vue'
import { 
  Button, 
  Dialog, 
  Pagination, 
  Loading, 
  Message, 
  MessageBox,
  Carousel,
  CarouselItem,
  divider,
  Select,
  Option,
} from 'element-ui'

Vue.use(Button);
Vue.use(Dialog);
Vue.use(Pagination);
Vue.use(Loading);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(divider);
Vue.use(Select);
Vue.use(Option);



Vue.use(Loading.directive);

Vue.prototype.$loading = Loading.service;

Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$confirm = MessageBox.confirm;



